import { toast } from 'sonner';

export type ConfirmAction = 'resetPassword' | 'deactivate' | null;

type ActionFn = (id: string, cb: { onSuccess: () => void; onError: () => void }) => void;

export function buildConfirmHandler({
  confirmAction,
  sendPasswordReset,
  deactivate,
  userId,
  clearAction,
}: {
  confirmAction: ConfirmAction;
  sendPasswordReset: ActionFn;
  deactivate: ActionFn;
  userId: string;
  clearAction: () => void;
}): () => void {
  return () => {
    const isReset = confirmAction === 'resetPassword';
    const action = isReset ? sendPasswordReset : deactivate;
    const okMsg = isReset ? 'Password reset email sent' : 'Super admin deactivated';
    const errMsg = isReset
      ? 'Failed to send password reset email'
      : 'Failed to deactivate super admin';
    action(userId, {
      onSuccess: () => {
        toast.success(okMsg);
        clearAction();
      },
      onError: () => toast.error(errMsg),
    });
  };
}
